import { Component, inject, OnDestroy } from '@angular/core'
import { ModalHeaderComponent } from '../modal-header/modal-header.component'
import { ModalBodyComponent } from '../modal-body/modal-body.component'
import { ModalFooterComponent } from '../modal-footer/modal-footer.component'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import { Subscription } from 'rxjs'
import {
  Filter,
  FilterService,
} from 'src/app/shared/services/filter/filter.service'
import { ActiveFilterListComponent } from '../../table/filters/active-filter-list/active-filter-list.component'
import { NamedDate } from 'src/app/shared/models/namedDate'
import { LabeledPropertyComponent } from '../../labeled-property/labeled-property.component'
import { DateRangeFilter, DateRangeFilterStateValue } from 'src/app/shared/services/filter/date-range-filter'
import { DateRangeFilterPickerComponent } from '../../date-range-filter-picker/date-range-filter-picker.component'
import { HeaderModal } from '../../table/headers/table-header.component'

export interface DateRangeFilterModalInit {
  namedDates?: NamedDate[];
}

@Component({
  imports: [
    ModalHeaderComponent,
    ModalBodyComponent,
    ModalFooterComponent,
    LabeledPropertyComponent,
    DateRangeFilterPickerComponent,
    ActiveFilterListComponent,
  ],
  selector: 'app-date-range-filter-modal',
  template: `
    @if(filter) {
      <div app-modal-header>{{ filter.state.config.meta.fieldDisplay }}</div>
      <div app-modal-body>
        <p>Select a date for the column {{ filter.state.config.meta.fieldDisplay }} below</p>
        <div app-labeled-property label="Date">
          <div dateRangeFilterPicker
            [value]="filter.state"
            (valueChange)="selectValue($event)"
            [showOperation]="filter.state.config.showOperation ?? false"
            [showRange]="filter.state.config.showRange ?? false"
            [showTime]="filter.state.config.showTime ?? false"
            [showSeconds]="filter.state.config.showSeconds ?? false"
            [onlyMonth]="filter.state.config.onlyMonth ?? false"
            [viewAsTZ]="filter.state.config.viewAsTZ ?? 'EST'"
          ></div>
        </div>
        <app-active-filter-list
          [filterGroup]=" filter.state.config.meta.fieldGroup"
          [filterName]=" filter.state.config.meta.fieldName"
        ></app-active-filter-list>
      </div>
      <div app-modal-footer>
        <button class="action-btn" (click)="onClose()">Close</button>
      </div>
    }
  `,
})
export class DateRangeFilterModalComponent implements OnDestroy, HeaderModal<DateRangeFilterModalInit> {
  private modal = inject(NgbActiveModal)
  private filterService = inject(FilterService)

  private subscription = new Subscription()
  protected fieldName = ''
  public filter: DateRangeFilter | undefined
  public modalInit: DateRangeFilterModalInit

  public init(
    fieldGroup: string,
    fieldName: string,
    modalInit: DateRangeFilterModalInit = {},
  ): void {
    this.fieldName = fieldName
    this.modalInit = modalInit
    this.subscription.add(
      this.filterService.state(fieldGroup).subscribe((group) => {
        const filter = group[fieldName] as Filter | undefined
        if (filter?.type === 'DATE_RANGE') {
          this.filter = filter
        }
      }),
    )
  }

  selectValue(value: DateRangeFilterStateValue) {
    if(this.filter) {
      this.filterService.dispatch(DateRangeFilter.SetDateRangeFilterValueAction(
        value, 
        this.filter.state.config.meta,
      ))
      this.onClose()
    }
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe()
  }

  onClose() {
    this.modal.close()
  }
}
